// @flow
import { themr } from 'react-css-themr';

import markerTheme from './FpPlanVisitMarker.scss';
import BeatVisitMarker from 'common/entity/pjpMaster/planView/BeatVisitMarker';
import { SpiderMarkerFactory } from 'common/components/core/markers/SpiderMarker';
import { spiderLocationMarkerFactory } from 'common/components/core/markers/SpiderLocationMarker';
import { animatedClusterMarkerFactory } from 'common/components/core/markers/AnimatedClusteredMarker';
import { CanvasShapeEnum } from 'common/enums/CanvasEnum';
import CanvasUtil from 'common/utils/CanvasUtil';
import { Color } from 'common/models/internal/Color';

const MARKER_HEIGHT = 24;
const MARKER_WIDTH = 20;
const SPIDER_MARKER_HEIGHT = 30;
const SPIDER_MARKER_WIDTH = 30;
const defaultPlanVisitMarkerStyle = {
    position: 'relative',
    height: MARKER_HEIGHT,
    width: MARKER_WIDTH
};

const defaultSpiderMarkerStyle = {
    position: 'absolute',
    width: SPIDER_MARKER_WIDTH,
    height: SPIDER_MARKER_HEIGHT,
    left: -SPIDER_MARKER_WIDTH / 2,
    top: -SPIDER_MARKER_HEIGHT / 2
};

const SpiderLocationFpPlanVisitMarker = spiderLocationMarkerFactory({
    Marker: BeatVisitMarker,
    options: {
        spiderMarkerStyle: defaultPlanVisitMarkerStyle,
        theme: markerTheme
    }
});

const SpiderMarker = SpiderMarkerFactory({
    SpiderPopupMarker: SpiderLocationFpPlanVisitMarker,
    spiderMarkerStyle: defaultSpiderMarkerStyle,
    options: {
        useTether: false
    }
});

const ThemedSpiderMarker = themr('SpiderMarker', markerTheme)(SpiderMarker);
const AnimatedSpiderMarker = animatedClusterMarkerFactory(ThemedSpiderMarker);

const drawSpiderMarkerOnCanvas = ({
    ctx,
    x,
    y,
    props
}: {
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    props: {
        label: string,
        canvasShape: $Values<typeof CanvasShapeEnum>,
        radius: number,
        color: Color,
        canvasIconFontSize: number
    }
}) => {
    const { color, label, canvasShape, radius } = props;
    let { canvasIconFontSize } = props;
    if (label === 'homebase') {
        // #HACK overriding homebase icon size
        canvasIconFontSize = 16;
    }
    CanvasUtil.drawShape({
        shape: canvasShape,
        ctx,
        x,
        y,
        color: color.code,
        radius,
        label,
        canvasIconFontSize
    });
};

AnimatedSpiderMarker.defaultProps = {
    isCanvasMarker: true,
    canvasShape: CanvasShapeEnum.SpiderCircle,
    drawOnCanvas: drawSpiderMarkerOnCanvas,
    radius: 9,
    canvasIconFontSize: 10
};
AnimatedSpiderMarker.displayName = 'AnimatedSpiderFpPlanVisitMarker';
export { AnimatedSpiderMarker as AnimatedSpiderFpPlanVisitMarker };
